export interface OrgMemberInfo {
  orgId: string;
  orgName: string;
  orgRole: string;
  userPermissions: string[];
  orgMetadata: Record<string, unknown>;
  urlSafeOrgName: string;
}

export interface UserData {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  orgIdToUserOrgInfo?: Record<string, OrgMemberInfo>;
  properties?: Record<string, unknown>;
  activeOrgId?: string;
  impersonatorUserId?: string;
}

export class User {
  constructor(private data: UserData) {}

  get userId(): string {
    return this.data.userId;
  }

  get email(): string {
    return this.data.email;
  }

  get firstName(): string | undefined {
    return this.data.firstName;
  }

  get lastName(): string | undefined {
    return this.data.lastName;
  }

  getOrgs(): OrgMemberInfo[] {
    if (!this.data.orgIdToUserOrgInfo) return [];
    return Object.values(this.data.orgIdToUserOrgInfo);
  }

  getOrg(orgId: string): OrgMemberInfo | undefined {
    return this.data.orgIdToUserOrgInfo?.[orgId];
  }

  getOrgByName(orgName: string): OrgMemberInfo | undefined {
    return this.getOrgs().find((org) => org.orgName === orgName);
  }
}
